exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color-yellow {\n  background: #ff9800 !important;\n  color: #000;\n}\n.color-green-text {\n  color: #008000;\n}\n.color-red-text {\n  color: #f00;\n}\n", ""]);

// exports
